import { AxiosPromise } from 'axios';

import { axios } from 'src/app/utils';
import { urlsConfig } from 'src/configs';
import { queryTypes, serviceTrainingObjectiveTypes } from 'src/types';
import { fileHelper, urlHelper } from '../helpers';

export const lookupTrainingObjectiveOfOntology = ({
  limit,
  offset,
  trainingObjectiveIds,
  value,
  order,
  sortOrder,
  blockSpinner,
  load,
  search,
}: serviceTrainingObjectiveTypes.TrainingObjectiveLookupDataType): AxiosPromise<serviceTrainingObjectiveTypes.TrainingObjectiveOfOntologyLookupResultType> => {
  const query: queryTypes.LookupQueryParametersType = {};

  if (trainingObjectiveIds) {
    query.trainingObjectiveIds = trainingObjectiveIds.join(',');
  }

  if (search) {
    query.search = search.join(',');
  }

  if (value) {
    query.search = value;
  }

  if (order && sortOrder) {
    query.order = order;
    query.sortOrder = sortOrder;
  }

  if (limit && offset) {
    query.limit = limit;
    query.offset = offset;
  }

  return axios.get(
    urlHelper.addQueryParameters(query, urlsConfig.trainingobjectiveofontology.lookupTrainingObjectiveOfOntology),
    {
      blockSpinner,
    },
  );
};
